import { temAcesso } from '@/shared/auth/temAcesso'
const RequisicaoInserir = () => import('./RequisicaoInserir.vue')
const RequisicaoAtualizar = () => import('./RequisicaoAtualizar.vue')
export default {
    path: 'requisicoes',
    name: 'Contratos_Requisicoes',
    component:  {
        render(c) {
            return c('router-view')
        },
    },
    meta: {
        requiresPermission: 'CONT-REQ-01'
    },
    children: [
        {
            path: 'inserir',
            name: 'Requisicoes_Inserir',
            component: RequisicaoInserir,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REQ-01')) {
                    next()
                }
            }
        },
        {
            path: 'atualizar/:idRequisicao',
            name: 'Contratos_Requisicoes_Atualizar',
            component: RequisicaoAtualizar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REQ-01')) {
                    next()
                }
            }
        }

    ]
}
